import { FiltersWidget } from '../FiltersWidget';
import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';

export class HideFiltersFilterWidget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'hideFilters';
        this.name = '';
        this.icon = '';
        this.resource = '';
        this.container = container;
        this.controller = new FiltersController();
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }


        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        // We only want non kitchen fab objects
        if (!FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            stringFilters += '&q.pipeline.unrealState.eq=ready';
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    };

    html(): void {
        this.isDestroyed = false;
        let html = this.filtersHtml() + `
        <div>
            ${!FilterGroup.previewAuto ? `
                <button id="startPreviewAuto" class="btn-default" title="Activer preview auto">
                    <i class="fas fa-lg fa-eye-slash"></i>
                    <span style="margin-left: 10px;">Activer preview auto</span>
                </button>
            ` : ''}
            ${FilterGroup.previewAuto ? `
                <button id="stopPreviewAuto" class="btn-default" title="Désactiver preview auto">
                    <i class="fas fa-lg fa-eye"></i>
                    <span style="margin-left: 10px;">Désactiver preview auto</span>
                </button>
            ` : ''}
        </div>
        `;

        setTimeout(() => {
            this.controller.addEventListener('mousedown', () => {
                FilterGroup.startStopPreviewAuto();
            }, 'startPreviewAuto');
            this.controller.addEventListener('mousedown', () => {
                FilterGroup.startStopPreviewAuto();
            }, 'stopPreviewAuto');
        }, 50);

        let container = document.getElementById(this.container);
        if (!container) {
            return;
        }
        container.innerHTML = html;
    }

    destroy(): void {
        super.destroy();
    }
}